export const CreateSalesOrder = `mutation CreateSalesOrder($orderno: String!, $locationid: ID!, $businessid: ID!, $createdby: ID!, $orderdate: String, $salesperson: String, $contactid: ID, $organizationid: ID, $orderitems: [SalesOrderItemInput], $status: Int, $expectedshipmentdate: String, $deliverymethod: String, $totalamount: Float, $totaldiscount: Float, $totaltax: Float, $physicaladdress: String, $currency: String, $orderattribute1: String, $orderattribute2: String, $orderattribute3: String, $orderattribute4: String, $orderattribute5: String, $orderattribute6: String, $orderattribute7: String, $orderattribute8: String, $orderattribute9: String, $orderattribute10: String, $orderattribute11: String, $orderattribute12: String, $orderattribute13: String, $orderattribute14: String, $orderattribute15: String, $orderattribute16: String, $orderattribute17: String, $orderattribute18: String, $orderattribute19: String, $orderattribute20: String, $orderattribute21: String, $orderattribute22: String, $orderattribute23: String, $orderattribute24: String, $orderattribute25: String, $orderattribute26: String, $orderattribute27: String, $orderattribute28: String, $orderattribute29: String, $orderattribute30: String, $orderattribute31: String, $orderattribute32: String, $orderattribute33: String, $orderattribute34: String, $orderattribute35: String, $orderattribute36: String, $orderattribute37: String, $orderattribute38: String, $orderattribute39: String, $orderattribute40: String, $orderattribute41: String, $orderattribute42: String, $orderattribute43: String, $orderattribute44: String, $orderattribute45: String, $orderattribute46: String, $orderattribute47: String, $orderattribute48: String, $orderattribute49: String, $orderattribute50: String) {
  createSalesOrder(orderno: $orderno, locationid: $locationid, businessid: $businessid, createdby: $createdby, orderdate: $orderdate, salesperson: $salesperson, contactid: $contactid, organizationid: $organizationid, orderitems: $orderitems, status: $status, expectedshipmentdate: $expectedshipmentdate, deliverymethod: $deliverymethod, totalamount: $totalamount, totaldiscount: $totaldiscount, totaltax: $totaltax, physicaladdress: $physicaladdress, currency: $currency, orderattribute1: $orderattribute1, orderattribute2: $orderattribute2, orderattribute3: $orderattribute3, orderattribute4: $orderattribute4, orderattribute5: $orderattribute5, orderattribute6: $orderattribute6, orderattribute7: $orderattribute7, orderattribute8: $orderattribute8, orderattribute9: $orderattribute9, orderattribute10: $orderattribute10, orderattribute11: $orderattribute11, orderattribute12: $orderattribute12, orderattribute13: $orderattribute13, orderattribute14: $orderattribute14, orderattribute15: $orderattribute15, orderattribute16: $orderattribute16, orderattribute17: $orderattribute17, orderattribute18: $orderattribute18, orderattribute19: $orderattribute19, orderattribute20: $orderattribute20, orderattribute21: $orderattribute21, orderattribute22: $orderattribute22, orderattribute23: $orderattribute23, orderattribute24: $orderattribute24, orderattribute25: $orderattribute25, orderattribute26: $orderattribute26, orderattribute27: $orderattribute27, orderattribute28: $orderattribute28, orderattribute29: $orderattribute29, orderattribute30: $orderattribute30, orderattribute31: $orderattribute31, orderattribute32: $orderattribute32, orderattribute33: $orderattribute33, orderattribute34: $orderattribute34, orderattribute35: $orderattribute35, orderattribute36: $orderattribute36, orderattribute37: $orderattribute37, orderattribute38: $orderattribute38, orderattribute39: $orderattribute39, orderattribute40: $orderattribute40, orderattribute41: $orderattribute41, orderattribute42: $orderattribute42, orderattribute43: $orderattribute43, orderattribute44: $orderattribute44, orderattribute45: $orderattribute45, orderattribute46: $orderattribute46, orderattribute47: $orderattribute47, orderattribute48: $orderattribute48, orderattribute49: $orderattribute49, orderattribute50: $orderattribute50) {
    salesorderid
  }
}`;

export const EditSalesOrder = `mutation EditSalesOrder($salesorderid: ID!, $updatedby: ID!, $orderno: String, $orderdate: String, $salesperson: String, $contactid: ID, $organizationid: ID, $status: Int, $expectedshipmentdate: String, $deliverymethod: String, $totalamount: Float, $totaldiscount: Float, $totaltax: Float, $salesownerid: ID, $currency: String, $orderitems: [SalesOrderItemInput], $physicaladdress: String, $orderattribute1: String, $orderattribute2: String, $orderattribute3: String, $orderattribute4: String, $orderattribute5: String, $orderattribute6: String, $orderattribute7: String, $orderattribute8: String, $orderattribute9: String, $orderattribute10: String, $orderattribute11: String, $orderattribute12: String, $orderattribute13: String, $orderattribute14: String, $orderattribute15: String, $orderattribute16: String, $orderattribute17: String, $orderattribute18: String, $orderattribute19: String, $orderattribute20: String, $orderattribute21: String, $orderattribute22: String, $orderattribute23: String, $orderattribute24: String, $orderattribute25: String, $orderattribute26: String, $orderattribute27: String, $orderattribute28: String, $orderattribute29: String, $orderattribute30: String, $orderattribute31: String, $orderattribute32: String, $orderattribute33: String, $orderattribute34: String, $orderattribute35: String, $orderattribute36: String, $orderattribute37: String, $orderattribute38: String, $orderattribute39: String, $orderattribute40: String, $orderattribute41: String, $orderattribute42: String, $orderattribute43: String, $orderattribute44: String, $orderattribute45: String, $orderattribute46: String, $orderattribute47: String, $orderattribute48: String, $orderattribute49: String, $orderattribute50: String) {
  editSalesOrder(salesorderid: $salesorderid, updatedby: $updatedby, orderno: $orderno, orderdate: $orderdate, salesperson: $salesperson, contactid: $contactid, organizationid: $organizationid, status: $status, expectedshipmentdate: $expectedshipmentdate, deliverymethod: $deliverymethod, totalamount: $totalamount, totaldiscount: $totaldiscount, totaltax: $totaltax, salesownerid: $salesownerid, currency: $currency, orderitems: $orderitems, physicaladdress: $physicaladdress, orderattribute1: $orderattribute1, orderattribute2: $orderattribute2, orderattribute3: $orderattribute3, orderattribute4: $orderattribute4, orderattribute5: $orderattribute5, orderattribute6: $orderattribute6, orderattribute7: $orderattribute7, orderattribute8: $orderattribute8, orderattribute9: $orderattribute9, orderattribute10: $orderattribute10, orderattribute11: $orderattribute11, orderattribute12: $orderattribute12, orderattribute13: $orderattribute13, orderattribute14: $orderattribute14, orderattribute15: $orderattribute15, orderattribute16: $orderattribute16, orderattribute17: $orderattribute17, orderattribute18: $orderattribute18, orderattribute19: $orderattribute19, orderattribute20: $orderattribute20, orderattribute21: $orderattribute21, orderattribute22: $orderattribute22, orderattribute23: $orderattribute23, orderattribute24: $orderattribute24, orderattribute25: $orderattribute25, orderattribute26: $orderattribute26, orderattribute27: $orderattribute27, orderattribute28: $orderattribute28, orderattribute29: $orderattribute29, orderattribute30: $orderattribute30, orderattribute31: $orderattribute31, orderattribute32: $orderattribute32, orderattribute33: $orderattribute33, orderattribute34: $orderattribute34, orderattribute35: $orderattribute35, orderattribute36: $orderattribute36, orderattribute37: $orderattribute37, orderattribute38: $orderattribute38, orderattribute39: $orderattribute39, orderattribute40: $orderattribute40, orderattribute41: $orderattribute41, orderattribute42: $orderattribute42, orderattribute43: $orderattribute43, orderattribute44: $orderattribute44, orderattribute45: $orderattribute45, orderattribute46: $orderattribute46, orderattribute47: $orderattribute47, orderattribute48: $orderattribute48, orderattribute49: $orderattribute49, orderattribute50: $orderattribute50)
}`;

export const DeleteSalesOrder = `mutation DeleteSalesOrder($salesorderid: ID!) {
    deleteSalesOrder(salesorderid: $salesorderid)
  }`;

export const SalesOrdersByLocation = `query SalesOrdersByLocation($locationid: ID!, $startdate: String, $enddate: String, $pagenumber: Int!, $pagesize: Int) {
  salesOrdersByLocation(locationid: $locationid, startdate: $startdate, enddate: $enddate, pagenumber: $pagenumber, pagesize: $pagesize) {
    rows {
      totaltax
      totaldiscount
      totalamount
      status
      salesperson
      salesorderid
      physicaladdress
      orderno
      orderdate
      expectedshipmentdate
      deliverymethod
      currency
      organization {
        name
        organizationid
      }
      contact {
        lastname
        firstname
        contactid
      }
      orderattribute9
      orderattribute8
      orderattribute7
      orderattribute6
      orderattribute50
      orderattribute5
      orderattribute49
      orderattribute48
      orderattribute47
      orderattribute46
      orderattribute45
      orderattribute44
      orderattribute43
      orderattribute42
      orderattribute41
      orderattribute40
      orderattribute4
      orderattribute39
      orderattribute38
      orderattribute37
      orderattribute36
      orderattribute35
      orderattribute34
      orderattribute33
      orderattribute32
      orderattribute31
      orderattribute30
      orderattribute3
      orderattribute29
      orderattribute28
      orderattribute27
      orderattribute26
      orderattribute25
      orderattribute24
      orderattribute23
      orderattribute22
      orderattribute21
      orderattribute20
      orderattribute2
      orderattribute19
      orderattribute18
      orderattribute16
      orderattribute17
      orderattribute15
      orderattribute14
      orderattribute13
      orderattribute12
      orderattribute11
      orderattribute10
      orderattribute1
    }
    count
  }
}`;

export const SalesOrder = `query SalesOrder($salesorderid: ID!) {
  salesOrder(salesorderid: $salesorderid) {
    salesorderid
    orderno
    orderdate
    salesperson
    status
    expectedshipmentdate
    deliverymethod
    totalamount
    totaldiscount
    totaltax
    salesownerid
    physicaladdress
    billingaddress
    currency
    locationid
    businessid
    contact {
      lastname
      firstname
      contactid
    }
    organization {
      name
      organizationid
    }
    orderitems {
      totalprice
      title
      singleitemprice
      salesorderitemid
      quantity
      productid
      description
      orderitemattribute9
      orderitemattribute8
      orderitemattribute7
      orderitemattribute6
      orderitemattribute5
      orderitemattribute50
      orderitemattribute49
      orderitemattribute48
      orderitemattribute47
      orderitemattribute46
      orderitemattribute45
      orderitemattribute44
      orderitemattribute42
      orderitemattribute43
      orderitemattribute41
      orderitemattribute40
      orderitemattribute4
      orderitemattribute39
      orderitemattribute38
      orderitemattribute37
      orderitemattribute36
      orderitemattribute35
      orderitemattribute34
      orderitemattribute33
      orderitemattribute32
      orderitemattribute31
      orderitemattribute30
      orderitemattribute3
      orderitemattribute29
      orderitemattribute28
      orderitemattribute27
      orderitemattribute26
      orderitemattribute25
      orderitemattribute24
      orderitemattribute23
      orderitemattribute22
      orderitemattribute21
      orderitemattribute20
      orderitemattribute2
      orderitemattribute19
      orderitemattribute18
      orderitemattribute17
      orderitemattribute16
      orderitemattribute15
      orderitemattribute14
      orderitemattribute13
      orderitemattribute12
      orderitemattribute11
      orderitemattribute10
      orderitemattribute1
    }
    orderattribute1
    orderattribute2
    orderattribute3
    orderattribute4
    orderattribute5
    orderattribute6
    orderattribute7
    orderattribute8
    orderattribute9
    orderattribute10
    orderattribute11
    orderattribute12
    orderattribute13
    orderattribute14
    orderattribute15
    orderattribute16
    orderattribute17
    orderattribute18
    orderattribute19
    orderattribute20
    orderattribute21
    orderattribute22
    orderattribute23
    orderattribute24
    orderattribute25
    orderattribute26
    orderattribute27
    orderattribute28
    orderattribute29
    orderattribute30
    orderattribute31
    orderattribute32
    orderattribute33
    orderattribute34
    orderattribute35
    orderattribute36
    orderattribute37
    orderattribute38
    orderattribute39
    orderattribute40
    orderattribute41
    orderattribute42
    orderattribute43
    orderattribute44
    orderattribute45
    orderattribute46
    orderattribute47
    orderattribute48
    orderattribute49
    orderattribute50
    createdAt
    updatedAt
  }
}`;

export const DeleteSalesOrderItem = `mutation DeleteSalesOrderItem($salesorderitemid: ID!) {
  deleteSalesOrderItem(salesorderitemid: $salesorderitemid)
}`;

export const SelectedGridColumns = `query SelectedGridColumns($ownerid: ID!) {
  selectedGridColumns(ownerid: $ownerid) {
    type
    table
    dbcolumnname
    columnname
  }
}`;
